// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__Zr9tH","footer":"ReportModalFilter_footer__3iSTn"};